// extracted by mini-css-extract-plugin
module.exports = {"partners":"Partners_partners__1gsJ8","item":"Partners_item__Ez_67","feat":"Partners_feat__OW_r9"};